import React from 'react';
import FeatureCards from "../../../../components/FeatureCards/FeatureCards";
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../../components/ServiceCards/ServiceCards";
import SEO from "../../../../utils/SEO";

export default function InsuranceReinsuranceLicenseMalta() {

    return (
        <main className='main'>
            <SEO
                title="Malta Insurance License | MFSA Reinsurance & Captive "
                description="Set up insurance and reinsurance companies in Malta. MFSA-regulated EU hub with Solvency II compliance, PCC structures, and EEA passporting rights. "
                keywords="Malta insurance license, MFSA insurance regulation, reinsurance Malta, captive insurance Malta, PCC Malta insurance, Solvency II Malta, EU insurance license, insurance licensing Malta "
                url="/insurance-reinsurance-license-malta"
            />

            <IntroSection
                title="Insurance & Reinsurance License – Malta (MFSA)"
                subtitle="Build Your Insurance or Reinsurance Business in the EU"
                description="<b>Malta</b> has become a <b>leading jurisdiction</b> for <b>insurance and reinsurance companies</b>, thanks to its <b>strong legal framework</b>, <b>EU membership</b>, and robust regulator, the <b>Malta Financial Services Authority (MFSA)</b>. Under <b>Solvency II</b>, <b>Malta-licensed insurers</b> enjoy <b>full passporting rights</b> across the <b>European Economic Area (EEA)</b>."
                badges={
                    [
                        "Captive Insurance",
                        "General Insurance",
                        "Reinsurance",
                        "Protected Cell Companies (PCCs)"
                    ]
                }
                buttonText="Request a Malta Insurance Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/services/gibraltar-crypto-dlt-license-hero.png")}
                imageAlt="jpeg"
            />

            <section className='section'>
                <div className="container">

                    <WhySection
                        title='Why Choose Malta for Insurance?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "EU Recognition",
                                                text: "Tier-1 regulatory credibility."
                                            },
                                            {
                                                title: "MFSA Regulated",
                                                text: "Fully aligned with Solvency II and FATF standards."
                                            },
                                            {
                                                title: "Passporting Rights",
                                                text: "Operate across all EEA markets with one license."
                                            },
                                            {
                                                title: "Captive Insurance Hub",
                                                text: "Attractive for corporate groups & multinationals."
                                            },
                                            {
                                                title: "Protected Cell Companies (PCCs)",
                                                text: "Malta pioneered PCC structures for insurance."
                                            },
                                            {
                                                title: "Banking & Investor Confidence",
                                                text: "EU credibility ensures trust and partnerships."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Types of Insurance & Reinsurance Licenses"
                        blocks={
                            [
                                {
                                    title: "Insurance License",
                                    items: [
                                        {
                                            text: "Life Insurance"
                                        },
                                        {
                                            text: "Non-Life (general) Insurance"
                                        },
                                        {
                                            text: "Captive Insurance for corporate groups"
                                        },
                                        {
                                            text: "Insurance linked to fintech, shipping, aviation, and other sectors"
                                        }
                                    ]
                                },
                                {
                                    title: "Reinsurance License",
                                    items:
                                        [
                                            {
                                                text: "Traditional Reinsurance"
                                            },
                                            {
                                                text: "Captive Reinsurance"
                                            },
                                            {
                                                text: "Alternative Risk Transfer (ART)"
                                            },
                                            {
                                                text: "Multi-jurisdictional reinsurance pools"
                                            }
                                        ]
                                },
                                {
                                    title: "Protected Cell Company (PCC) License",
                                    items:
                                        [
                                            {
                                                text: "Special structure unique to Malta"
                                            },
                                            {
                                                text: "Allows multiple insurance businesses to operate under one umbrella company"
                                            },
                                            {
                                                text: "Each “cell” is legally segregated, offering cost savings & flexibility"
                                            }
                                        ]
                                },
                            ]
                        }
                    />

                    <LocationTimeline
                        title="Capital Requirements (Solvency II)"
                        subtitle=''
                        item={
                            [
                                {
                                    title: "General Insurance",
                                    text: "€3,700,000 minimum."
                                },
                                {
                                    title: "Life Insurance",
                                    text: "€3,700,000 minimum."
                                },
                                {
                                    title: "Captive Insurance",
                                    text: "€2,500,000 minimum."
                                },
                                {
                                    title: "Reinsurance Companies",
                                    text: "€3,600,000 minimum."
                                },
                                {
                                    title: "PCCs",
                                    text: "Depend on structure, lower entry for each individual cell."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Benefits of a Malta Insurance License'
                        services={
                            [
                                {
                                    title: "EU Passporting",
                                    text: "Access to 30+ EEA markets."
                                },
                                {
                                    title: "Prestige & Trust",
                                    text: "Tier-1 jurisdiction recognized globally."
                                },
                                {
                                    title: "Captive & PCC Options",
                                    text: "Efficient structures for corporate groups."
                                },
                                {
                                    title: "Banking Access",
                                    text: "Strong support from EU banks and reinsurers."
                                },
                                {
                                    title: "Scalable",
                                    text: "Start with a captive or cell, expand to full insurer."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Consultation & Planning",
                                    text: "Choose insurance, reinsurance, or PCC structure."
                                },
                                {
                                    title: "Company Incorporation",
                                    text: "Register in Malta with MFSA oversight."
                                },
                                {
                                    title: "Application Submission",
                                    text: "Business plan, solvency projections, risk framework."
                                },
                                {
                                    title: "MFSA Review & Interviews",
                                    text: "Due diligence on shareholders, directors, compliance."
                                },
                                {
                                    title: "License Approval",
                                    text: "Typically within 9–12 months."
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={
                            [
                                {
                                    name: "Timeline",
                                    duration: "9–12 months.",
                                },
                                {
                                    name: "Setup Costs",
                                    description: "from €150,000+ (legal, actuarial, compliance)."
                                },
                                {
                                    name: "Capital Requirement",
                                    description: "€2.5M–€3.7M+ depending on license type."
                                },
                                {
                                    name: "Annual Costs",
                                    description: "audits, compliance, MFSA supervisory fees."
                                },

                            ]
                        }
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    text: "Experts in EU insurance & reinsurance licensing."
                                },
                                {
                                    text: "Guidance on captive & PCC structures."
                                },
                                {
                                    text: "End-to-end service: incorporation, compliance, actuarial support, license filing."
                                },
                                {
                                    text: "Introductions to reinsurance partners, actuarial consultants, and EU banks."
                                },
                                {
                                    text: "Clear comparison: Malta vs Offshore alternatives (Mwali, Anjouan, Western Sahara)."
                                }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to establish an EU insurance or reinsurance company?"
                        description="Malta offers Tier-1 credibility, EU passporting rights, and innovative PCC structures."
                        buttonText="Book a Malta Insurance Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Why Malta for insurance?",
        content: [
            { type: "answer", text: "Malta is one of the EU’s leading captive & PCC hubs, with strong Solvency II credibility." },
        ],
    },
    {
        question: "What is a Protected Cell Company (PCC)?",
        content: [
            { type: "answer", text: "A structure where multiple insurance businesses share one umbrella license, while each cell is legally ring-fenced." },
        ],
    },
    {
        question: "What are the capital requirements?",
        content: [
            { type: "answer", text: "From €2.5M (captives) up to €3.7M+ for life/non-life insurers." },
        ],
    },
    {
        question: "Can we operate across the EU?",
        content: [
            { type: "answer", text: "Yes — all Malta insurance & reinsurance licenses benefit from EEA passporting rights." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "Usually 9–12 months depending on structure and complexity." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "Our multinational set up a captive in Malta with Offshore Advisory. The PCC structure saved us significant costs.",
        author: "David R.",
        role: "Corporate Risk Director"
    },
    {
        quote: "We established a reinsurance company in Malta. Offshore Advisory guided us through actuarial requirements and MFSA procedures.",
        author: "Anna L.",
        role: "Reinsurance CEO"
    }
];